import {createStore, legacy_createStore, applyMiddleware, compose} from 'redux';
import rootReducer from '../reducers/index.js';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import thunkMiddleware from 'redux-thunk';


 


let enhancers;
 
    enhancers = applyMiddleware(thunkMiddleware );
 

export default function configureStore(initialState) {

    return legacy_createStore(
        rootReducer,
        initialState,
        enhancers
    );
}




 
 